const AssetEnum = {
  CURRENCY      : 'Currency',
  COMMODITY     : 'Commodity',
  INTERBANK_RATE: 'InterbankRate'
}

export default AssetEnum
